import { Form, InputGroup } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import './HowDidYouHear.scss';

function HowDidYouHear() {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext();
  return (
    <div className="how-did-you-hear col-sm-8 d-none d-sm-block">
      <div className="how-did-you-hear-title">How did you hear about Urbain?</div>
      <div className="radio-button-container col-12">
        <div className="radio-button-column col-4">
          <div className="radio">
            <Form.Check type={'radio'} id="owner" value="owner" label="From another Urbain owner" {...register('Referral')} />
          </div>
          <div className="radio">
            <Form.Check type={'radio'} id="member" value="member" {...register('Referral')} label="From an Urbain member" />
          </div>
          <div className="radio">
            <Form.Check type={'radio'} id="word" value="word" {...register('Referral')} label="General word of mouth" />
          </div>
        </div>
        <div className="radio-button-column col-4">
          <div className="radio">
            <Form.Check type={'radio'} id="search" value="search" {...register('Referral')} label="Online search (Google)" />
          </div>
          <div className="radio">
            <Form.Check type={'radio'} id="review" value="review" {...register('Referral')} label="Online Review" />
          </div>
          <div className="radio">
            <Form.Check type={'radio'} id="social" value="social" {...register('Referral')} label="Social Media" />
          </div>
        </div>
        <div className="radio-button-column col-4">
          <div className="radio">
            <Form.Check type={'radio'} id="advertisment" value="advertisment" {...register('Referral')} label="Print Advertisment" />
          </div>
          <div className="radio">
            <Form.Check type={'radio'} id="event" value="event" {...register('Referral')} label="Event/Conference" />
          </div>
          <div className="radio">
            <InputGroup>
              <InputGroup.Prepend>
                <Form.Check type={'radio'} id="other" value="other" {...register('Referral')} label="Other: " />
              </InputGroup.Prepend>
              <Form.Control {...register('ReferralOther')} className="other-input" aria-label="Text input with radio button" />
            </InputGroup>
          </div>
        </div>
      </div>
    </div>
  );
}
export default HowDidYouHear;
